<template>
  <button class="QuizAnswer">
    <span>{{ answer.label }}</span>
    <i class="far fa-check"></i>
  </button>
</template>

<script>
  export default {
    name: "QuizAnswer",
    props: [ 'answer' ]
  }
</script>

<style lang="stylus" scoped>
.QuizAnswer

  position relative
  background: white;
  box-shadow: 0 2px 10px 0 rgba(0,0,0,0.10);
  border-radius: 5px;
  font-family $f-title
  letter-spacing -0.3px
  font-weight 500
  font-size 14px
  color $blue
  line-height 17px
  box-sizing border-box
  display block
  height 100px
  width 185px
  text-align center
  border 0px
  appearance none
  overflow hidden
  cursor pointer
  transition all 0.2s $ease

  @media $large

    width 145px
    height 80px

  @media $medium

    width 100%
    height 50px
    text-align left 
    line-height 14px
    padding 0px 20px

  span

    position relative
    display block
    transition transform 0.6s $ease

    b

      font-weight 500


    @media $medium

      width calc(100% - 30px)

  i

    font-size 18px
    position absolute
    top 50%
    left 50%
    color white
    opacity 0
    transform translate(-50%, 250%)
    transition opacity 0.2s $ease, transform 0.4s $ease

    @media $medium

      transform translate(0%, 250%)
      left auto
      right 20px


  &_selected

    background $blue
    color white

    span

      transform translateY(calc(-50% + 5px))

      @media $medium

        transform none

    i

      transform translate(-50%, 70%)
      opacity 1

      @media $medium

        transform translate(0%, -50%)

  &:hover

    background $blue
    color white

.ie

  .QuizAnswer_selected

    i

      transform translate(-50%, 120%)
</style>